import { AssessmentEntry, ICourseInfo, IInstitutionInfo } from '@/models';
import { IValidator, isYearValid } from '@/models/validation/IValidator';
import { IScorePolicy } from '../services/collegetransfer/entities';

export class AssessmentEntryValidator implements IValidator<AssessmentEntry> {
	public isNullOrWhitespace(val: string | null) {
		return (val || '').trim() === '';
	}

	public isValid(val: AssessmentEntry): boolean {
		return isYearValid(val.academicYear)
			&& this.isCourseValid(val.course)
			&& this.isInstitutionValid(val.institution)
			&& this.isScoreValid(val.score, val.institution.scorePolicy);
	}

	public isCourseValid(course: ICourseInfo | null): boolean {
		return course !== null && course.value !== null;
	}

	public isInstitutionValid(institution: IInstitutionInfo | null): boolean {
		return institution !== null && !this.isNullOrWhitespace(institution.value);
	}

	public isScoreValid(score: string | null, scorePolicy: IScorePolicy | null): boolean {
		if (scorePolicy === null || score === null) {
			return true;
		}

		if (scorePolicy.UseCustomScores) {
			return scorePolicy.CustomScores.find((s) => s.Display === score) !== undefined;
		}
		const scoreNum = +score;
		const min = scorePolicy.LowScore || 0;
		const max = scorePolicy.HighScore || Number.MAX_SAFE_INTEGER;
		return scoreNum >= min && scoreNum <= max;
	}
}

export default new AssessmentEntryValidator();
